// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4572176e","488":"cc5fe7df","977":"d321334c"}[chunkId] + ".chunk.js";
};